import * as yup from "yup";

const emptySchema = yup.object().shape({});

export default emptySchema;
